// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vk-overlay {
  position: fixed;
  inset: 0;
  z-index: 200000; /* ensure keys are clickable even with modal open */
  display: flex;
  align-items: flex-end;
  justify-content: center;
  font-family: var(--ion-font-family, inherit);
}

.vk-backdrop {
  position: absolute;
  inset: 0;
  background: transparent; /* keep clickable area without dimming */
}

.vk-panel {
  position: relative;
  width: 100vw;
  max-width: 100vw;
  height: auto; /* shrink to content to avoid large white area */
  background: var(--ion-background-color, #fff);
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  box-shadow: 0 -6px 24px rgba(0, 0, 0, 0.2);
  padding: 12px 12px 10px 12px;
}

.vk-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 4px 4px 8px;
}

.vk-title {
  font-weight: 600;
  font-size: 16px;
}

.vk-input-preview {
  flex: 1;
  text-align: center;
  font-size: 18px;
  padding: 6px 10px;
  background: var(--ion-color-step-50, #f5f5f5);
  border-radius: 8px;
  min-height: 36px;
}

.vk-btn {
  border: none;
  background: var(--ion-color-medium, #ccc);
  color: #111;
  padding: 8px 12px;
  border-radius: 8px;
  cursor: pointer;
}

.vk-close {
  background: var(--ion-color-danger, #eb445a);
  color: #fff;
}

.vk-confirm {
  background: var(--ion-color-primary, #3880ff);
  color: #fff;
  width: 100%;
  padding: 12px;
  font-size: 18px;
}

.vk-body {
  padding: 2px 0;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.vk-row {
  display: flex;
  gap: 8px;
  justify-content: center;
  margin: 6px 0;
}

.vk-row.vk-symbols {
  justify-content: flex-start;
}

.vk-key {
  min-width: 96px;
  min-height: 96px;
  border-radius: 12px;
  font-size: 30px;
  border: none;
  background: var(--ion-color-light, #f2f2f2);
  color: var(--ion-text-color, #000);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.vk-key[disabled] {
  opacity: 0.4;
  pointer-events: none;
}

.vk-func {
  background: var(--ion-color-medium, #ccc);
}

.vk-wide {
  min-width: 240px;
}

.vk-space {
  min-width: 42%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/inapp-keyboard/inapp-keyboard.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,QAAA;EACA,eAAA,EAAA,mDAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,4CAAA;AACF;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,uBAAA,EAAA,wCAAA;AACF;;AAEA;EACE,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA,EAAA,gDAAA;EACA,6CAAA;EACA,4BAAA;EACA,6BAAA;EACA,0CAAA;EACA,4BAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,oBAAA;AACF;;AAEA;EAAY,gBAAA;EAAkB,eAAA;AAG9B;;AAFA;EACE,OAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,6CAAA;EACA,kBAAA;EACA,gBAAA;AAKF;;AAFA;EACE,YAAA;EACA,yCAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AAKF;;AAHA;EAAY,4CAAA;EAA8C,WAAA;AAQ1D;;AAPA;EAAc,6CAAA;EAA+C,WAAA;EAAa,WAAA;EAAa,aAAA;EAAe,eAAA;AAetG;;AAbA;EAAW,cAAA;EAAgB,YAAA;EAAc,aAAA;EAAe,sBAAA;EAAwB,2BAAA;AAqBhF;;AApBA;EAAU,aAAA;EAAe,QAAA;EAAU,uBAAA;EAAyB,aAAA;AA2B5D;;AA1BA;EAAqB,2BAAA;AA8BrB;;AA5BA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,2CAAA;EACA,kCAAA;EACA,wCAAA;AA+BF;;AA7BA;EACE,YAAA;EACA,oBAAA;AAgCF;;AA9BA;EAAW,yCAAA;AAkCX;;AAjCA;EAAW,gBAAA;AAqCX;;AApCA;EAAY,cAAA;AAwCZ","sourcesContent":[".vk-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 200000; /* ensure keys are clickable even with modal open */\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  font-family: var(--ion-font-family, inherit);\n}\n\n.vk-backdrop {\n  position: absolute;\n  inset: 0;\n  background: transparent; /* keep clickable area without dimming */\n}\n\n.vk-panel {\n  position: relative;\n  width: 100vw;\n  max-width: 100vw;\n  height: auto; /* shrink to content to avoid large white area */\n  background: var(--ion-background-color, #fff);\n  border-top-left-radius: 16px;\n  border-top-right-radius: 16px;\n  box-shadow: 0 -6px 24px rgba(0,0,0,0.2);\n  padding: 12px 12px 10px 12px;\n}\n\n.vk-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 4px 4px 8px;\n}\n\n.vk-title { font-weight: 600; font-size: 16px; }\n.vk-input-preview {\n  flex: 1;\n  text-align: center;\n  font-size: 18px;\n  padding: 6px 10px;\n  background: var(--ion-color-step-50, #f5f5f5);\n  border-radius: 8px;\n  min-height: 36px;\n}\n\n.vk-btn {\n  border: none;\n  background: var(--ion-color-medium, #ccc);\n  color: #111;\n  padding: 8px 12px;\n  border-radius: 8px;\n  cursor: pointer;\n}\n.vk-close { background: var(--ion-color-danger, #eb445a); color: #fff; }\n.vk-confirm { background: var(--ion-color-primary, #3880ff); color: #fff; width: 100%; padding: 12px; font-size: 18px; }\n\n.vk-body { padding: 2px 0; height: auto; display: flex; flex-direction: column; justify-content: flex-start; }\n.vk-row { display: flex; gap: 8px; justify-content: center; margin: 6px 0; }\n.vk-row.vk-symbols { justify-content: flex-start; }\n\n.vk-key {\n  min-width: 96px;\n  min-height: 96px;\n  border-radius: 12px;\n  font-size: 30px;\n  border: none;\n  background: var(--ion-color-light, #f2f2f2);\n  color: var(--ion-text-color, #000);\n  box-shadow: 0 1px 2px rgba(0,0,0,0.2);\n}\n.vk-key[disabled] {\n  opacity: 0.4;\n  pointer-events: none;\n}\n.vk-func { background: var(--ion-color-medium, #ccc); }\n.vk-wide { min-width: 240px; }\n.vk-space { min-width: 42%; }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
